import { useUserStore } from '~/stores/user'
import { useLogger } from '~/composables/useLogger'

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return

  const userStore = useUserStore()
  const logger = useLogger()
  const publicRoutes = ['/auth', '/privacy', '/terms', '/support', '/pricing', '/', '/download']
  const restrictedLoggedInRoutes = ['/auth']

  try {
    // If already logged in and profile is fetched, skip the check
    let isLoggedIn = userStore.isLoggedIn

    // Only check login status if not already logged in or profile not fetched
    if (!isLoggedIn && !publicRoutes.includes(to.path)) {
      isLoggedIn = await userStore.checkLoginStatus()
    }

    userStore.setAuthChecking(false)

    if (isLoggedIn && restrictedLoggedInRoutes.includes(to.path)) {
      return navigateTo('/dashboard/home')
    }

    // Protect private routes
    if (!isLoggedIn && !publicRoutes.includes(to.path)) {
      return navigateTo('/auth')
    }
  } catch (error) {
    logger.logError('Auth middleware error:', error)
    userStore.setAuthChecking(false)
    if (!publicRoutes.includes(to.path)) {
      return navigateTo('/auth')
    }
  }
})
